export const environment = {
  production: true,
  endpointFront: 'https://cms.ggenergies.co.uk/api/',
  imgUrlLocal: 'https://cms.ggenergies.co.uk/images',
  endpointForms: 'https://ggenergies.co.uk/apiGG/',
  recaptcha: {
    siteKey: '6LfdWTIjAAAAAN4SoDYkpPiOjpRPV0nSlsiB2wR6',
  },
};

